export abstract class BaseFormatter 
{
    protected formatDateTime(date: Date)
    {
        return this.formatDate(date) + " " + this.formatTime(date);
    }
    protected formatDate(date: Date)
    {
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = String(date.getDate()).toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
    protected formatTime(date: Date)
    {
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        return `${hours}:${minutes}:${seconds}`;
    }
    protected qoute(text: string, size: number, filler: string)
    {
        let count = (size - text.length) / 2;
        text = text.padStart(text.length + count, filler);
        text = text.padEnd(size, filler);
        return text;
    }
    protected getMesssages(messages: any[]): string[]
    {
        return messages.map(x =>
        {
            if (typeof (x) == "object")
                return JSON.stringify(x, undefined, 4);
            return x + "";
        });
    }
}